import React from 'react';

import { SVGProps } from './SVGProps';

const DashboardMenuIcon = ({ fill = '#101828', width = '24', height = '25' }: SVGProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 12.1368H21M3 6.13678H21M3 18.1368H15" stroke={fill} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default DashboardMenuIcon;
